import React from "react";
import { SectionInterface } from "../interfaces/Section";
import Communication from "../assets/communication.jpg";
// import { motion, useScroll, useTransform } from "framer-motion";

const SectionBelow3 = ({
  sectionInterface,
}: {
  sectionInterface: SectionInterface;
}) => {
  // const ref = useRef<HTMLDivElement | null>(null);

  // obserwujemy widoczność sekcji
  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["0 1", "1 0"],
  //   /*
  //     "0 1" = kiedy górna krawędź elementu dotknie dolnej krawędzi viewport
  //     "1 0" = kiedy dolna krawędź elementu dotknie górnej krawędzi viewport
  //   */
  // });

  // mapujemy progress (0 → 1) na przesunięcie w osi X§
  // np. na początku jest +200px, w połowie +100px, na końcu 0
  // element osiąga docelową pozycję już przy scrollYProgress = 0.5
  // const x = useTransform(scrollYProgress, [0, 0.5], [150, 0]);
  // const opacity = useTransform(scrollYProgress, [0, 0.5], [0, 1]);

  return (
    <div className="w-full bg-white py-16 px-4">
      {/* <motion.div */}
        {/* ref={ref} */}
        {/* style={{ x, opacity }} */}
        <div className="max-w-[1240px] mx-auto grid md:grid-cols-2 items-center gap-6">
      {/* > */}
        <div>
          <img className="w-[500px] mx-auto my-4" src={Communication} alt="/" />
        </div>
        <div className="flex flex-col justify-center p-2">
          <p className="text-[#00df9a] font-bold">
            COLLABORATION AND COMMUNICATION
          </p>
          <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-2">
            Risk reduction + smoother project delivery
          </h1>
          <p>
            Successful projects are built on clear communication and teamwork. I
            have experience working in international teams, managing tasks in
            agile environments, and sharing knowledge openly. With me, you can
            expect transparency, reliability, and a strong partnership that
            reduces risks and ensures timely delivery.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionBelow3;
